module.exports = __webpack_public_path__ + "static/L5Y2-0c0458b459b1caa712dc882c7d40bd7c.jpg";